import React, { useState, useEffect } from "react";
import { View } from "react-native";

import { firebaseMain } from "@/firebaseConfig";
import { ScrollView, Stack } from "native-base";
import styled from "styled-components";
import { Track } from "@/Models/Track";
import MixHorizontalComponent from "./MixHorizontalComponent";

const Title = styled.span`
    font-family: Outfit_700Bold;
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
    text-align: left;
    color: #ffffff;
    margin-bottom: 16px;
`;
const RecentlyPlayed = () => {
    const [tracks, setTracks] = useState<Track[]>([]);

    useEffect(() => {
        const fetchTracks = async () => {
            const featureTrackDocs = await firebaseMain
                .firestore()
                .collection("featuredTracks")
                .get();
            const trackRefs = featureTrackDocs.docs.map((doc) => doc.id);
            console.log("featureTrackDocs", featureTrackDocs.docs);

            console.log("trackRefs", trackRefs);
            // Assuming trackRefs.length <= 10
            /*const trackQuerySnapshot = await firebaseMain
                .firestore()
                .collection("tracks")
                .where(
                    firebaseMain.firestore.FieldPath.documentId(),
                    "in",
                    trackRefs
                )
                .get();*/
            /*const tracks = trackQuerySnapshot.docs.map(
                (doc) => ({ id: doc.id, ...doc.data() } as Track)
            );*/

            // Assuming trackRefs.length <= 10
            const trackQuerySnapshot = await firebaseMain
                .firestore()
                .collection("tracks")
                .where(
                    firebaseMain.firestore.FieldPath.documentId(),
                    "in",
                    trackRefs
                )
                .get();

            const trackAndDJPromises = trackQuerySnapshot.docs.map(
                async (doc) => {
                    const track = { id: doc.id, ...doc.data() } as Track;
                    const djDoc = await firebaseMain
                        .firestore()
                        .collection("profiles")
                        .doc(track.djRef)
                        .get();
                    track.dj = { id: djDoc.id, ...djDoc.data() } as DJ;
                    return track;
                }
            );
            const tracks = await Promise.all(trackAndDJPromises);
            setTracks(tracks);
        };

        fetchTracks();
    }, []);

    console.log("tracks", tracks);

    return (
        <View>
            <Title>Recently Played</Title>
            <ScrollView>
                <Stack overflowX={"scroll"} space="2.5" direction="column">
                    {tracks.map((track) => (
                        <MixHorizontalComponent key={track.id} track={track} />
                    ))}
                </Stack>
            </ScrollView>
        </View>
    );
};

export default RecentlyPlayed;
